export default "__VITE_ASSET__CVTbxtPB__"